export default "__VITE_ASSET__3Ev4L0hT__";